import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    variants: {
      variant: {
        default: '',
        card: 'border border-[transparent]',
      },
      disabled: {
        true: 'cursor-default',
      },
      error: {
        true: 'border-systemError',
      },
    },
  }),
  checkbox: tv({
    base: 'h-[2.2rem] w-[2.2rem] items-center justify-center rounded-xs bg-accentPrimary20',
    variants: {
      checked: {
        true: 'bg-accentPrimary40',
      },
      disabled: {
        true: 'bg-neutral30',
      },
    },
  }),
};
